// extracted by mini-css-extract-plugin
export default {"shippingStatusContainer":"GD-z","shipmentMessage":"HD-z","shipmentNumber":"ID-z","trackingProgressContainer":"JD-z"};